import Buefy from "buefy";
import "buefy/dist/buefy.css";
import Vidle from "v-idle";
import Vue from "vue";
import { firestorePlugin, rtdbPlugin } from "vuefire";
import App from "./App.vue";
import "./assets/css/global.css";
import "vue-chessboard/dist/vue-chessboard.css";
import router from "./router";
import store from "./store/store";
Vue.use(Vidle);

import titleMixin from "./mixins/titleMixin";
Vue.mixin(titleMixin);

import "./filters";

import VueGoogleCharts from "vue-google-charts";
Vue.use(VueGoogleCharts);

Vue.use(firestorePlugin);
Vue.use(rtdbPlugin);
Vue.use(Buefy, {
  defaultIconPack: "fas",
});
Vue.config.productionTip = false;

Vue.directive("visible", function (el, binding) {
  el.style.visibility = binding.value ? "visible" : "hidden";
});

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { messages } from "vee-validate/dist/locale/en.json";
import * as rules from "vee-validate/dist/rules";

// Register it globally
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule]
      ? messages[rule].slice(3, messages[rule].length).replace(" field", "")
      : undefined, // assign message
  });
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
